module.exports = __webpack_public_path__ + "img/settlement.cfe00546.png";